module.exports = __webpack_public_path__ + "img/loginImg.f807254f.png";